export const formatMoneyCents = (value) => {
    if (isNaN(value)) {
        return '-'
    }
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(value)
}

export const formatMoney = (value) => {
    value = Math.round(value);
    if (isNaN(value)) {
        return '-';
    }
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }).format(value)
}